import { Flex } from "../../../../styled";
import Select from "../../../shared/_FormInputs/Select";
import ReportDatesInputs from "../../../shared/Reports/ReportDatesInputs";
import CheckboxGroup from "../../../shared/_FormInputs/CheckboxGroup/CheckboxGroup";
import { useEffect, useMemo } from "react";
import useIsFleet from "../useIsFleet";
import { vesselFields } from "../../../shared/Reports/VesselReports.utils";

interface Props {
  methods: any;
  yachts: any[];
  setStartDate: (date: string) => void;
  setEndDate: (date: string) => void;
}

const ReportVesselInputs = ({
  methods,
  yachts,
  setEndDate,
  setStartDate,
}: Props) => {
  const isFleet = useIsFleet();
  const { watch, setValue, control } = methods;
  const dates = watch("vessel.dates");
  const type = watch("vessel.type");

  useEffect(() => {
    setValue("vessel.fields", []);
  }, [type]);

  const matchedCustomFileds = useMemo(
    () => (Object.keys(vesselFields).includes(type) ? vesselFields[type] : []),
    [type],
  );

  return (
    <Flex gap="lg">
      <Flex direction="column" gap="sm">
        <Select
          control={control}
          name="vessel.type"
          label="Report Type"
          data={[
            { value: "0", label: "Standard Report" },
            { value: "1", label: "Subscription Renewals" },
            { value: "2", label: "Vessel Overview Report" },
          ]}
        />
        <Select
          control={control}
          name="vessel.status"
          label="Vessel Status"
          data={[
            { value: "0", label: "All" },
            { value: "1", label: "Active" },
            { value: "2", label: "Inactive" },
            { value: "3", label: "Archived" },
          ]}
        />
      </Flex>
      <Flex direction="column">
        {type !== "1" && (
          <ReportDatesInputs
            control={control}
            datesSelectorWatchValue={dates}
            startInputName="vessel.start"
            endInputName="vessel.end"
            datesInputName="vessel.dates"
            additionalSetStartDate={setStartDate}
            additionalSetEndDate={setEndDate}
          />
        )}
      </Flex>

      <div style={{ width: "250px" }}>
        <CheckboxGroup
          name="vessel.vessels"
          title="Vessels"
          control={control}
          data={yachts}
          disabled={false}
          grouped={!isFleet}
        />
      </div>
      {matchedCustomFileds?.length > 0 && (
        <div>
          <CheckboxGroup
            name="vessel.fields"
            title="Fields"
            control={control}
            data={matchedCustomFileds}
            disabled={false}
            grouped={!isFleet}
            scrollHeight={300}
          />
        </div>
      )}
    </Flex>
  );
};
export default ReportVesselInputs;
